import { render, staticRenderFns } from "./CommitteeStatsReport.vue?vue&type=template&id=1a61e58c&scoped=true"
import script from "./CommitteeStatsReport.vue?vue&type=script&lang=js"
export * from "./CommitteeStatsReport.vue?vue&type=script&lang=js"
import style0 from "./CommitteeStatsReport.vue?vue&type=style&index=0&id=1a61e58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61e58c",
  null
  
)

export default component.exports